export default __webpack_public_path__ + "images/M9.a5d06b7.png";